<script>
  export default {
    props: {
      acessoObjeto: {},  
      turma: {}, 
      labelsLinguagemSelecionada: {
        type: Object,
        required: true
      },
      labelsDadosLinguagemSelecionada: {
        type: Object,
        required: true
      },
    },
    data() {
      return {
      }
    },
    computed: {
        labelIsento(){
            return this.labelsLinguagemSelecionada.labels.isentoInscricao;
        },
        labelDuracao() {
            return 'Duração\Dia e horário';
        },
        labelMetodologia() {
            return this.labelsLinguagemSelecionada.labels.metodolodiaCurso;
        },
        mostrarLinhaAnterior() {
            if (!this.turma.naoMostrarDataInicioInscricao)
                return true;

            if (!this.turma.naoMostrarDataFimInscricao)
                return true;

            if (!this.turma.naoMostrarDataInicioCurso)
                return true;

            if (!this.turma.naoMostrarDataFimCurso)
                return true;

            if (this.turma.numeroMensalidades > 0)
                return true;

            if (this.turma.valorMensalidade > 0)
                return true;

            return false;
        },        
    },
    methods: {
      nl2br(str) {
        var breakTag = '<br>';
        return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
        },
        valorCategoria(faixa) {
            if (!faixa.valor)
                return '---';         

            return this.$options.filters.formatarNumero(faixa.valor);
        },
    },
  }
</script>

<style scoped>
    .info {
        font-size: 1.20em;
        color: #1d9d74;
        margin-right: 3px;
    }
</style>

<template>
  <div>
    <div class="row">
      <dl class="col-xs-6 col-sm-2" v-if="!turma.naoMostrarDataInicioInscricao">
        <dt>{{ this.labelsLinguagemSelecionada.labels.dataInicioInscricao }} <i class="fa fa-info-circle infoSol" v-tooltip="'dd/mm/yyyy'" v-if="labelsLinguagemSelecionada.simbolo != 'pt-Br'"></i></dt>
        <dd>
          {{ turma.dataInicioInscTurma ? turma.dataInicioInscTurma : '---' }}
        </dd>
      </dl>
      <dl class="col-xs-6 col-sm-2" v-if="!turma.naoMostrarDataFimInscricao">
        <dt>{{ this.labelsLinguagemSelecionada.labels.dataFimInscricao }} <i class="fa fa-info-circle infoSol" v-tooltip="'dd/mm/yyyy'" v-if="labelsLinguagemSelecionada.simbolo != 'pt-Br'"></i></dt>
        <dd>
          {{ turma.dataLimiteInscTurma ? turma.dataLimiteInscTurma : '---' }}
        </dd>
      </dl>
      <dl class="col-xs-6 col-sm-2" v-if="!turma.naoMostrarDataInicioCurso">
        <dt>{{ this.labelsLinguagemSelecionada.labels.dataInicioCurso }} <i class="fa fa-info-circle infoSol" v-tooltip="'dd/mm/yyyy'" v-if="labelsLinguagemSelecionada.simbolo != 'pt-Br'"></i></dt>
        <dd>
          {{ turma.dataInicioTurma ? turma.dataInicioTurma : '---' }}
        </dd>
      </dl>
      <dl class="col-xs-6 col-sm-2" v-if="!turma.naoMostrarDataFimCurso">
        <dt>{{ this.labelsLinguagemSelecionada.labels.dataFimCurso }} <i class="fa fa-info-circle infoSol" v-tooltip="'dd/mm/yyyy'" v-if="labelsLinguagemSelecionada.simbolo != 'pt-Br'"></i></dt>
        <dd>
          {{ turma.dataFimTurma ? turma.dataFimTurma : '---' }}
        </dd>
      </dl>
      <dl class="col-xs-6 col-sm-2" v-if="turma.numeroMensalidades > 0">
        <dt>{{ this.labelsLinguagemSelecionada.labels.parcelas }}</dt>
        <dd>
          {{ turma.numeroMensalidades ? turma.numeroMensalidades : '---' }}
        </dd>
      </dl>
      <dl class="col-xs-6 col-sm-2" v-if="turma.valorMensalidade > 0">
        <dt>{{ this.labelsLinguagemSelecionada.labels.valorParcela }}</dt>
        <dd>
          {{ turma.valorMensalidade | formatarNumero }}
        </dd>
      </dl>
    </div>

    <div class="hr-line-dashed margin-top-20" v-if="mostrarLinhaAnterior"></div>

    <div class="row" v-if="turma.urlDirecionamento || turma.instagramCursoEventoDoacao">
        <div class="table-responsive" align='center'>
            <table class="table table-bordered" style="width: auto;">
                <colgroup>
                    <col style="width: 100px;" v-if="turma.urlDirecionamento">
                    <col style="width: 100px;" v-if="turma.instagramCursoEventoDoacao">
                </colgroup>
                <tbody>
                    <tr>
                        <td style="text-align: center;" v-if="turma.urlDirecionamento">
                            <a :href="turma.urlDirecionamento" target="_blank">
                                <img src="img/acesso/atalhos/logo_site.png" alt="Site Oficial" style="width:42px;height:42px;" v-tooltip="'Site Oficial'">
                            </a>
                        </td>
                        <td style="text-align: center;" v-if="turma.instagramCursoEventoDoacao">
                            <a :href="turma.instagramCursoEventoDoacao" target="_blank">
                                <img src="img/acesso/atalhos/logo_instagram.png" alt="Instagram" style="width:42px;height:42px;" v-tooltip="'Instagram'">
                            </a>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>

    <div class="hr-line-dashed" style="margin-top: 0px;" v-if="turma.urlDirecionamento || turma.instagramCursoEventoDoacao"></div>

    <div class="row">
      <dl class="col-xs-12">
        <dt></dt>
        <dd>
          <div class="table-responsive">
            <table class="table table-bordered table-column-action">
              <thead>
                <tr>
                  <th style="text-align: left;">{{ this.labelsLinguagemSelecionada.labels.categorias }}</th>
                  <th>{{ this.labelsLinguagemSelecionada.labels.valorCategorias }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(faixaValor, index) in turma.faixaValores">
                  <td style="text-align: left;">{{ faixaValor.descricao || '---' }}</td>
                  <td v-if="faixaValor.valor > 0">{{ valorCategoria(faixaValor) }}</td>
                  <td v-else >{{ labelIsento }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </dd>
      </dl>
    </div>

    <div class="row" v-if="labelsDadosLinguagemSelecionada.informacoes">

        <dl class="col-xs-12">
            <dt>{{ this.labelsLinguagemSelecionada.labels.informacaoCurso }}</dt>
            <dd v-html="nl2br(labelsDadosLinguagemSelecionada.informacoes)">
                {{ nl2br(labelsDadosLinguagemSelecionada.informacoes) }}
            </dd>
        </dl>

    </div>

    <div name="adicionais">
      <div class="row" v-if="labelsDadosLinguagemSelecionada.observacoes">

        <dl class="col-xs-12">
          <dt>{{ this.labelsLinguagemSelecionada.labels.observacoesCurso }}</dt>
          <dd v-html="nl2br(labelsDadosLinguagemSelecionada.observacoes)">
              {{ nl2br(labelsDadosLinguagemSelecionada.observacoes) }}
          </dd>
        </dl>

      </div>

      <div class="row" v-if="labelsDadosLinguagemSelecionada.justificativa">

        <dl class="col-xs-12">
          <dt>{{ this.labelsLinguagemSelecionada.labels.justificativaCurso }}</dt>
          <dd v-html="labelsDadosLinguagemSelecionada.justificativa">
              {{ labelsDadosLinguagemSelecionada.justificativa }}
          </dd>
        </dl>

      </div>

      <div class="row" v-if="labelsDadosLinguagemSelecionada.objetivos">

        <dl class="col-xs-12">
          <dt>{{ this.labelsLinguagemSelecionada.labels.objetivosCurso }}</dt>
          <dd v-html="labelsDadosLinguagemSelecionada.objetivos">
              {{ labelsDadosLinguagemSelecionada.objetivos }}
          </dd>
        </dl>

      </div>

      <div class="row" v-if="labelsDadosLinguagemSelecionada.metodologia">

        <dl class="col-xs-12">
          <dt>{{ labelMetodologia }}</dt>
          <dd v-html="labelsDadosLinguagemSelecionada.metodologia">
              {{ labelsDadosLinguagemSelecionada.metodologia }}
          </dd>
        </dl>

      </div>

      <div class="row" v-if="labelsDadosLinguagemSelecionada.infraestrutura">

        <dl class="col-xs-12">
          <dt>{{ this.labelsLinguagemSelecionada.labels.infraestruturaCurso }}</dt>
          <dd v-html="labelsDadosLinguagemSelecionada.infraestrutura">
              {{ labelsDadosLinguagemSelecionada.infraestrutura }}
          </dd>
        </dl>

      </div>

      <div class="row" v-if="labelsDadosLinguagemSelecionada.ementaDisciplina">

          <dl class="col-xs-12">
              <dt>{{ this.labelsLinguagemSelecionada.labels.ementaCurso }}</dt>
              <dd v-html="nl2br(labelsDadosLinguagemSelecionada.ementaDisciplina)">
                  {{ nl2br(labelsDadosLinguagemSelecionada.ementaDisciplina) }}
              </dd>
          </dl>

      </div>

      <div class="row" v-if="labelsDadosLinguagemSelecionada.preRequisito">

          <dl class="col-xs-12">
              <dt>{{ this.labelsLinguagemSelecionada.labels.preRequisitoCurso }}</dt>
              <dd v-html="nl2br(labelsDadosLinguagemSelecionada.preRequisito)">
                  {{ nl2br(labelsDadosLinguagemSelecionada.preRequisito) }}
              </dd>
          </dl>

      </div>

      <div class="row" v-if="labelsDadosLinguagemSelecionada.publicoAlvo">

          <dl class="col-xs-12">
              <dt>{{ this.labelsLinguagemSelecionada.labels.publicoCurso }}</dt>
              <dd v-html="nl2br(labelsDadosLinguagemSelecionada.publicoAlvo)">
                  {{ nl2br(labelsDadosLinguagemSelecionada.publicoAlvo) }}
              </dd>
          </dl>

      </div>


      <div class="row" v-if="labelsDadosLinguagemSelecionada.investimento">

          <dl class="col-xs-12">
              <dt>{{ this.labelsLinguagemSelecionada.labels.valorCategoriasCurso }}</dt>
              <dd v-html="nl2br(labelsDadosLinguagemSelecionada.investimento)">
                  {{ nl2br(labelsDadosLinguagemSelecionada.investimento) }}
              </dd>
          </dl>

      </div>

      <div class="row" v-if="labelsDadosLinguagemSelecionada.formaPagamento">

          <dl class="col-xs-12">
              <dt>{{ this.labelsLinguagemSelecionada.labels.formasPagamentoCurso }}</dt>
              <dd v-html="nl2br(labelsDadosLinguagemSelecionada.formaPagamento)">
                  {{ nl2br(labelsDadosLinguagemSelecionada.formaPagamento) }}
              </dd>
          </dl>

      </div>

      <div class="row" v-if="labelsDadosLinguagemSelecionada.devolucaoInscricao">

          <dl class="col-xs-12">
              <dt>{{ this.labelsLinguagemSelecionada.labels.devolucaoCurso }}</dt>
              <dd v-html="nl2br(labelsDadosLinguagemSelecionada.devolucaoInscricao)">
                  {{ nl2br(labelsDadosLinguagemSelecionada.devolucaoInscricao) }}
              </dd>
          </dl>

      </div>

      <div class="row" v-if="labelsDadosLinguagemSelecionada.local">

          <dl class="col-xs-12">
              <dt>{{ this.labelsLinguagemSelecionada.labels.localCurso }}</dt>
              <dd v-html="nl2br(labelsDadosLinguagemSelecionada.local)">
                  {{ nl2br(labelsDadosLinguagemSelecionada.local) }}
              </dd>
          </dl>

      </div>

      <div class="row" v-if="labelsDadosLinguagemSelecionada.duracao">

          <dl class="col-xs-12">
              <dt>{{ this.labelsLinguagemSelecionada.labels.duracaoCurso }}</dt>
              <dd v-html="nl2br(labelsDadosLinguagemSelecionada.duracao)">
                  {{ nl2br(labelsDadosLinguagemSelecionada.duracao) }}
              </dd>
          </dl>

      </div>

      <div class="row" v-if="labelsDadosLinguagemSelecionada.areaConhecimento">

          <dl class="col-xs-12">
              <dt>{{ this.labelsLinguagemSelecionada.labels.areaConhecimentoCurso }}</dt>
              <dd v-html="nl2br(labelsDadosLinguagemSelecionada.areaConhecimento)">
                  {{ nl2br(labelsDadosLinguagemSelecionada.areaConhecimento) }}
              </dd>
          </dl>

      </div>

      <div class="row" v-if="labelsDadosLinguagemSelecionada.outrasInformacoes">

          <dl class="col-xs-12">
              <dt>{{ this.labelsLinguagemSelecionada.labels.outrasInformacoes }}</dt>
              <dd v-html="nl2br(labelsDadosLinguagemSelecionada.outrasInformacoes)">
                  {{ nl2br(labelsDadosLinguagemSelecionada.outrasInformacoes) }}
              </dd>
          </dl>

      </div>
    </div>
  </div>
</template>

<style>
  dd, dt {
    letter-spacing: 1.5px;
  }

  div.adicionais dl {
    padding-bottom:10px;
  }
</style>



// WEBPACK FOOTER //
// FrontEnd/modulos/acessos/componentes/compartilhado/AcessoTiposDetalhamentoCursoEvento.vue